import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import classnames from 'classnames';
import withLoader from 'components/organisms/withLoader';
import {
  checkIsInactive,
  generateFullName,
  getIndicatorColor,
} from 'utils/badgeHelpers';
import HeartIcon from '../icons/heartIcon';

const PatientMobileNameRiskStatusBadge = ({
  profile,
  patientDetailsLoading,
  riskScore,
}) => {
  const { birthDate, title, firstName, middleName, lastName, status } = profile;
  const isInactive = useMemo(() => checkIsInactive(status), status);
  return (
    <>
      {withLoader(
        patientDetailsLoading,
        <div className="mobile-name-badge risk-badge">
          <>
            <div className="fullName">
              {generateFullName(title, firstName, middleName, lastName)}
            </div>
            <div className="birthDate">{birthDate?.replaceAll('-', '/')}</div>
            <div
              className={classnames(
                'status',
                { inactive: isInactive },
                { active: !isInactive },
              )}
            />
            {Number.isInteger(riskScore) && (
              <div className="risk-score risk-score--position">
                <div className="risk-score__title">Risk Score {riskScore}</div>
                <div className="risk-score__indicator">
                  <HeartIcon color={getIndicatorColor(riskScore)} />
                </div>
              </div>
            )}
          </>
        </div>,
      )}
    </>
  );
};

PatientMobileNameRiskStatusBadge.defaultProps = {
  patientDetailsLoading: false,
};

PatientMobileNameRiskStatusBadge.propTypes = {
  profile: PropTypes.shape().isRequired,
  riskScore: PropTypes.number,
  patientDetailsLoading: PropTypes.bool,
};

export default PatientMobileNameRiskStatusBadge;
